/* Shared by the static homepage/mobile entries and the bundled download page. */
(function () {
  'use strict';
  if (window.UniverseBeanSpeech) return;
  // Verified iFlytek pairs only; absence means browser fallback, never the opposite gender.
  var languageVoices = Object.freeze({female:Object.freeze({yue:'x3_xiaoyue',shanghai:'x3_ziling',sichuan:'x3_xiaodu',ja:'x2_JaJp_ZhongCun',ko:'x2_KoKr_Miya',ar:'x2_ArEn_Rania'}),male:Object.freeze({henan:'x2_xiaokun'})});
  var dialects = Object.freeze({sichuan:true,shanghai:true,henan:true});
  function normalizeLanguage(language) {
    var aliases = {jp:'ja',kor:'ko',fra:'fr',spa:'es',ara:'ar',pot:'pt-BR',chengdu:'sichuan',cn:'zh','zh-CN':'zh'};
    return aliases[language] || language || 'zh';
  }
  function genderForAgent(agent) {
    var gender = agent && (Object.prototype.hasOwnProperty.call(agent, 'gender') ? agent.gender : agent.xingxiang && agent.xingxiang.gender);
    return gender === 'female' || gender === 'male' ? gender : undefined;
  }
  function speechGender(agent) { return genderForAgent(agent) || 'male'; }
  function voiceForLanguage(language, agent) {
    language = normalizeLanguage(language);
    if (['zh','zh-TW','en'].indexOf(language) >= 0) {
      var raw = agent && Object.prototype.hasOwnProperty.call(agent, 'fayinren') ? agent.fayinren : agent && agent.ttsVoice;
      var voice = String(raw || '').trim();
      var defaultGender = language === 'en' ? speechGender(agent) : genderForAgent(agent);
      if (voice === 'x4_mingge') return 'x6_lingbosong_pro';
      if (/(?:xiaoyan(?:$|[^a-z])|小燕)/i.test(voice)) return defaultGender === 'male' ? 'x6_lingbosong_pro' : 'x4_lingxiaolu_em_v2';
      return voice && ['无','null','undefined'].indexOf(voice.toLowerCase()) < 0 ? voice : defaultGender === 'male' ? 'x6_lingbosong_pro' : 'x4_lingxiaolu_em_v2';
    }
    var gender = typeof agent === 'string' ? agent : speechGender(agent);
    var matched = languageVoices[gender] && languageVoices[gender][language];
    if (!matched && gender && (dialects[language] || language === 'yue' || language === 'nan-TW')) {
      if (gender === 'male') return voiceForLanguage('zh', Object.assign({},typeof agent === 'string'?{}:agent,{gender:'male'}));
      return 'x4_lingxiaolu_em_v2';
    }
    return matched;
  }
  // Adult identities from https://learn.microsoft.com/azure/ai-services/speech-service/language-support?tabs=tts
  // Web Speech has no gender property. Match only documented provider identities, not arbitrary names.
  var browserPairs = {'zh-CN':['Xiaoxiao','Yunxi'],'zh-TW':['HsiaoChen','YunJhe'],'en-US':['Jenny','Guy'],'zh-HK':['HiuMaan','WanLung'],'ja-JP':['Nanami','Keita'],'ko-KR':['SunHi','InJoon'],'hi-IN':['Swara','Madhur'],'es-ES':['Elvira','Alvaro'],'ar-SA':['Zariyah','Hamed'],'fr-FR':['Denise','Henri'],'bn-BD':['Nabanita','Pradeep'],'bn-IN':['Tanishaa','Bashkar'],'pt-PT':['Raquel','Duarte'],'pt-BR':['Francisca','Antonio'],'ru-RU':['Svetlana','Dmitry'],'id-ID':['Gadis','Ardi'],'ur-PK':['Uzma','Asad'],'ur-IN':['Gul','Salman']};
  browserPairs['es-AR'] = ['Elena', 'Tomas'];
  browserPairs['ar-AE'] = ['Fatima', 'Hamdan'];
  browserPairs['fr-BE'] = ['Charline', 'Gerard'];
  function browserVoice(language, agent) {
    var gender = typeof agent === 'string' ? agent : speechGender(agent);
    if (!gender || !window.speechSynthesis) return undefined;
    language = normalizeLanguage(language);
    var tags = {zh:['zh-CN'],'zh-TW':['zh-TW'],yue:['zh-HK','yue-HK'],pt:['pt-PT','pt-BR'],'pt-BR':['pt-BR','pt-PT']}[language];
    if (!tags) tags = Object.keys(browserPairs).filter(function (tag) { return tag.toLowerCase() === language.toLowerCase() || tag.toLowerCase().indexOf(language.toLowerCase() + '-') === 0; });
    var voices = window.speechSynthesis.getVoices();
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i], pair = browserPairs[tag === 'yue-HK' ? 'zh-HK' : tag];
      if (!pair) continue;
      var name = pair[gender === 'female' ? 0 : 1];
      var found = voices.find(function (voice) {
        var locale = String(voice.lang || '').replace(/_/g, '-').toLowerCase();
        if (locale !== tag.toLowerCase() && locale !== tag.split('-')[0].toLowerCase()) return false;
        // Edge uses a localized display suffix, e.g. "Japanese (Japan)", not "ja-JP".
        // Match the provider's voice identity and locale separately from that display label.
        var label = String(voice.name || '').trim().toLowerCase();
        var prefix = ('Microsoft ' + name + ' Online (Natural) - ').toLowerCase();
        return label === (tag + '-' + name + 'Neural').toLowerCase() || label.indexOf(prefix) === 0;
      });
      if (found) return found;
    }
  }
  function waitForBrowserVoice(language, agent, signal) {
    // Chinese male speech must retain its configured cloud identity; never substitute a browser voice.
    if (speechGender(agent) === 'male' && ['zh','zh-TW','yue','nan-TW','shanghai','sichuan','henan'].indexOf(normalizeLanguage(language)) >= 0) return Promise.resolve(undefined);
    var voice = browserVoice(language, agent), synth = window.speechSynthesis;
    if (voice || !synth || (signal && signal.aborted)) return Promise.resolve(voice);
    return new Promise(function (resolve) {
      var timer;
      function done(value) { clearTimeout(timer); if (synth.removeEventListener) synth.removeEventListener('voiceschanged', changed); if (signal) signal.removeEventListener('abort', aborted); resolve(value); }
      function changed() { var available = browserVoice(language, agent); if (available) done(available); }
      function aborted() { done(undefined); }
      if (synth.addEventListener) synth.addEventListener('voiceschanged', changed);
      if (signal) signal.addEventListener('abort', aborted, {once:true});
      timer = setTimeout(function () { done(browserVoice(language, agent)); }, 1500);
      changed();
    });
  }
  var owner = window;
  try { if (window.top.location.origin === window.location.origin) owner = window.top; } catch (_) {}
  var key = 'universe-bean-muted';
  var hub = owner.__universeBeanSpeechHub;
  if (!hub) {
    var muted = false;
    try { muted = owner.localStorage.getItem(key) === 'true'; } catch (_) {}
    hub = owner.__universeBeanSpeechHub = { muted: muted, clients: [], context: null };
  }

  function nextMessageId() { return 'speech-' + (hub.messageSequence = (hub.messageSequence || 0) + 1); }
  function messageForNode(node, agent) {
    var data = node.dataset || {}, parent = node.closest && node.closest('[data-speech-language],[data-copy-language],[data-render-language],[lang]');
    var inherited = parent && parent !== node ? messageForNode(parent, agent) : null;
    if (!data.speechId) data.speechId = nextMessageId();
    return {id:data.speechId,text:String(node.textContent || '').trim(),language:data.speechLanguage || data.copyLanguage || data.renderLanguage || node.lang || (inherited && inherited.language) || 'zh',agent:agent && Object.assign({},agent)};
  }
  function availability(language, agent) {
    language = normalizeLanguage(language);
    var gender = speechGender(agent), voice = voiceForLanguage(language, agent);
    var fallback = !!voice && !(languageVoices[gender] && languageVoices[gender][language]) && (dialects[language] || language === 'yue' || language === 'nan-TW');
    return {available:!!voice || !!browserVoice(language, agent),voice:voice,fallbackLanguage:fallback ? 'zh' : null};
  }
  function voiceHint(language,agent) { var value=availability(language,agent);return value.fallbackLanguage?'（使用普通话）':value.available?'':'（当前设备无可用声音）'; }
  function prepareFixedText(text, isFixedCopy, language) {
    text = String(text || '');
    text = text.replace(/&(?:lt|#0*60|#x0*3c);/gi, '<').replace(/&(?:gt|#0*62|#x0*3e);/gi, '>');
    // Strip actual markup and named decorations, not mathematical relations.
    var markup=/<(p|div|span|strong|em|b|i|a|ul|ol|li|h[1-6])(?:\s[^>]*)?\s*>([\s\S]*?)<\/\1\s*>/gi;
    var previous;do{previous=text;text=text.replace(markup,'$2');}while(text!==previous);
    text=text.replace(/<br\s*\/?\s*>/gi,' ');
    text = text.replace(/[<＜]([^<>＜＞\d=]+)[>＞]/g, function(match,inner) {
      return !/^\s|\s$/.test(inner) && (/[\u3400-\u9fff]/.test(inner) || ((isFixedCopy || match[0]==='＜') && inner.length>1)) ? inner : match;
    });
    language = normalizeLanguage(language).split('-')[0];
    var words={en:[' less than ',' greater than ',' or equal to '],ja:[' 未満 ',' より大きい ','以下'],ko:[' 보다 작음 ',' 보다 큼 ',' 또는 같음 '],fr:[' inférieur à ',' supérieur à ',' ou égal à '],es:[' menor que ',' mayor que ',' o igual a '],pt:[' menor que ',' maior que ',' ou igual a '],ru:[' меньше ',' больше ',' или равно '],id:[' kurang dari ',' lebih dari ',' atau sama dengan '],hi:[' से कम ',' से अधिक ',' या बराबर '],ar:[' أصغر من ',' أكبر من ',' أو يساوي '],bn:[' এর চেয়ে ছোট ',' এর চেয়ে বড় ',' অথবা সমান '],ur:[' سے کم ',' سے زیادہ ',' یا برابر ']}[normalizeLanguage(language)];
    if(words){var lessEqual=language==='ja'?' 以下 ':words[0]+words[2],greaterEqual=language==='ja'?' 以上 ':words[1]+words[2];return text.replace(/[<＜]=/g,lessEqual).replace(/[>＞]=/g,greaterEqual).replace(/[<＜]/g,words[0]).replace(/[>＞]/g,words[1]);}
    return text.replace(/[<＜]=/g,'小于等于').replace(/[>＞]=/g,'大于等于').replace(/[<＜]/g,'小于').replace(/[>＞]/g,'大于');
  }

  function splitText(text) {
    var chunks = [], chunk = '', bytes = 0;
    String(text || '').trim().split(/(?<=[。！？!?])\s*|\n+|(?<=\.)\s+(?=[A-Z])/u).forEach(function(sentence){
    Array.from(sentence).forEach(function (letter) {
      var code = letter.codePointAt(0);
      var size = code <= 127 ? 1 : code <= 2047 ? 2 : code <= 65535 ? 3 : 4;
      if (bytes + size > 7200) { chunks.push(chunk); chunk = ''; bytes = 0; }
      chunk += letter;
      bytes += size;
    });
    if (chunk) chunks.push(chunk);chunk='';bytes=0;
    });
    return chunks;
  }

  async function playStream(response, context, signal, onPlaying, timeoutMs) {
    var reader = response.body.getReader(), nodes = new Set(), pending = '', tail = '', rate = 0;
    var decoder = new TextDecoder(), ended = false, started = false, nextTime = 0, finishDrain;
    var drained = new Promise(function (resolve) { finishDrain = resolve; });
    function abort() {
      reader.cancel().catch(function () {});
      nodes.forEach(function (node) { node.onended = null; try { node.stop(); } catch (_) {} node.disconnect(); });
      nodes.clear(); finishDrain();
    }
    function checkAbort() { if (signal.aborted) { var error = new Error('请求已取消'); error.name = 'AbortError'; throw error; } }
    function packet(event) {
      if (ended) throw new Error('音频结束后收到额外数据');
      if (event.type === 'error') throw new Error(event.message || '语音合成中断');
      if (event.type === 'end') { ended = true; if (!nodes.size) finishDrain(); return; }
      if (event.type !== 'audio' || ![16000, 24000].includes(event.sampleRate) || (rate && rate !== event.sampleRate)) throw new Error('音频格式无效');
      rate = event.sampleRate;
      var bytes = tail + atob(event.audio), count = Math.floor(bytes.length / 2);
      tail = bytes.slice(count * 2);
      if (!count) return;
      var buffer = context.createBuffer(1, count, rate), samples = buffer.getChannelData(0);
      for (var i = 0; i < count; i++) {
        var value = bytes.charCodeAt(i * 2) | (bytes.charCodeAt(i * 2 + 1) << 8);
        samples[i] = (value >= 32768 ? value - 65536 : value) / 32768;
      }
      var node = context.createBufferSource(); node.buffer = buffer; node.connect(context.destination); nodes.add(node);
      node.onended = function () { node.disconnect(); nodes.delete(node); if (ended && !nodes.size) finishDrain(); };
      nextTime = Math.max(nextTime, context.currentTime + (started ? 0.02 : 0.12));
      var scheduledStart = nextTime;
      node.start(nextTime); nextTime += buffer.duration;
      started = true; onPlaying(scheduledStart);
    }
    signal.addEventListener('abort', abort, { once: true });
    try {
      checkAbort();
      while (true) {
        var part = await deadline(reader.read(), timeoutMs || 15000, signal); checkAbort();
        pending += decoder.decode(part.value || new Uint8Array(), { stream: !part.done });
        if (pending.length > 24 * 1024 * 1024) throw new Error('音频数据过大');
        var newline;
        while ((newline = pending.indexOf('\n')) >= 0) {
          var line = pending.slice(0, newline); pending = pending.slice(newline + 1);
          if (line.trim()) packet(JSON.parse(line));
        }
        if (part.done) break;
      }
      if (!ended || pending.trim() || tail || !started) throw new Error('语音流提前中断或音频不完整');
      // Autoplay may suspend an already buffered stream until a user gesture.
      // Keep network deadlines above, but start the playback deadline only when audio can run.
      if (context.state !== 'running') await new Promise(function (resolve, reject) {
        function finish(error) {
          context.removeEventListener('statechange', changed);
          signal.removeEventListener('abort', cancelled);
          if (error) reject(error); else resolve();
        }
        function cancelled() { var error = new Error('请求已取消'); error.name = 'AbortError'; finish(error); }
        function changed() {
          if (signal.aborted) cancelled();
          else if (context.state === 'running') finish();
          else if (context.state === 'closed') finish(new Error('语音播放已关闭，请重试。'));
        }
        context.addEventListener('statechange', changed);
        signal.addEventListener('abort', cancelled, { once: true });
        changed();
      });
      checkAbort();
      await deadline(drained, Math.max(15000, (nextTime - context.currentTime) * 1000 + 15000), signal); checkAbort();
    } catch (error) { error.audioStarted = started; abort(); throw error; }
    finally { signal.removeEventListener('abort', abort); reader.releaseLock(); }
  }

  function deadline(promise, ms, signal) {
    if (typeof setTimeout !== 'function') return promise;
    return new Promise(function(resolve,reject) {
      var timer, done = false;
      function finish(error,value) { if(done)return;done=true;clearTimeout(timer);if(signal)signal.removeEventListener('abort',abort);error?reject(error):resolve(value); }
      function abort() { var error=new Error('请求已取消');error.name='AbortError';finish(error); }
      timer=setTimeout(function(){var error=new Error('语音请求超时，请重试。');error.name='TimeoutError';finish(error);},ms);
      if(signal && signal.aborted)abort();else if(signal)signal.addEventListener('abort',abort,{once:true});
      Promise.resolve(promise).then(value=>finish(null,value),error=>finish(error));
    });
  }

  function create(options) {
    // Content embedded in an answer must never register a second speaker with the host hub.
    if (window.parent !== window && window.name === 'website-content-module') {
      var silent = function () {};
      return {open:silent,speak:function(){return Promise.resolve({status:'muted'});},stop:silent,syncMuted:silent,unlock:silent,
        isMuted:function(){return true;},isOpening:function(){return false;},sequence:function(){return 0;},setMuted:silent,destroy:silent};
    }
    var overlay = options.overlay, button = options.button;
    var serial = 0, controller = null, source = null, finishPlayback = null, destroyed = false;
    var currentAgent = '';
    var browserUtterance = null;
    var introPending = false;
    var streaming = false;
    var lastMessage = null, activeMessage = null, statusNode = null;
    var agentHandoff = null;
    // Count audible explanation, never a queued request or identity greeting.
    var explainedContexts = new Set();
    function explanationContext() {
      if (overlay.dataset.platformIntro) return 'platform:'+overlay.dataset.platformIntro;
      return String(options.getIntro() || '').replace(/^(?:你好[啊呀哇]?|您好[啊呀哇]?)，我是[^。\n]+。\s*/, '').trim();
    }
    function notice(text) {
      if(statusNode){if(statusNode.parentElement && statusNode.parentElement.classList.contains('agent-speech-card'))statusNode.parentElement.style.removeProperty('overflow');statusNode.remove();statusNode=null;}
    }
    function publish(status, text) {
      if (!activeMessage) return;
      var EventType = window.CustomEvent || (typeof CustomEvent === 'function' && CustomEvent);
      if (EventType && window.dispatchEvent) window.dispatchEvent(new EventType('bean-speech', {detail:Object.assign({},activeMessage,{status:status,text:text || activeMessage.text,owner:overlay})}));
    }

    function visible() {
      if (document.hidden || overlay.dataset.beanHostOpen === 'false' || getComputedStyle(overlay).visibility === 'hidden') return false;
      if (!overlay.isConnected || overlay.hidden || overlay.getAttribute('aria-hidden') === 'true' || !overlay.getClientRects().length) return false;
      try {
        var frame = window.frameElement;
        while (frame) {
          if (!frame.getClientRects().length) return false;
          frame = frame.ownerDocument.defaultView.frameElement;
        }
      } catch (_) {}
      return true;
    }

    function stop(clearCurrent) {
      openingWork = null;
      publish('cancelled');activeMessage=null;
      if(clearCurrent){lastMessage=null;notice('');}
      serial += 1;
      introPending = false;
      if (controller) controller.abort();
      controller = null;
      streaming = false;
      if (browserUtterance) { window.speechSynthesis.cancel(); browserUtterance = null; }
      if (source) { try { source.stop(); } catch (_) {} source.disconnect(); source = null; }
      if (finishPlayback) { finishPlayback(); finishPlayback = null; }
      overlay.dataset.beanSpeech = 'idle';
    }

    function syncMuted() {
      if (hub.muted) stop();
      button.setAttribute('aria-pressed', String(hub.muted));
      button.setAttribute('aria-label', hub.muted ? '取消静音' : '静音');
      button.title = hub.muted ? '取消静音' : '静音';
      var icon = button.querySelector('.bean-chat-mute-icon');
      if (icon) icon.textContent = hub.muted ? '🔇' : '🔊';
      overlay.querySelectorAll('audio, video').forEach(function (media) { media.muted = hub.muted; });
    }

    function unlock() {
      if (destroyed || hub.muted) return;
      var Context = owner.AudioContext || owner.webkitAudioContext;
      if (!Context) return;
      if (!hub.context) hub.context = new Context();
      if (hub.context.state === 'suspended') {
        hub.context.resume().then(function () {
          if (source || streaming) overlay.dataset.beanSpeech = 'playing';
        }).catch(function () {});
      }
    }

    async function runSpeech(text, agent, isIntro, contentLanguage, metadata) {
      stop();
      notice('');
      lastMessage=Object.assign({},metadata || {},{text:text,agent:agent,isIntro:isIntro,language:contentLanguage});
      activeMessage=Object.assign({},lastMessage,{id:lastMessage.id || nextMessageId()});
      
      text = prepareFixedText(text, isIntro, contentLanguage || (isIntro && (overlay.querySelector('.bean-chat-intro-message p') || {dataset:{}}).dataset.copyLanguage) || 'zh');
      if (isIntro) activeMessage.text = text;
      var chunks = splitText(text);
      activeMessage.remainingText=chunks.join('');
      publish('queued');
      if (destroyed || !visible() || !chunks.length) return Promise.resolve();
      // Muted greetings still have visible copy, but only after the actor enters.
      if (hub.muted) {
        if(activeMessage.agentGreeting){
          var silentVersion=serial;
          controller=new AbortController();
          var silentReady=!overlay.waitForAgentSpeech || await overlay.waitForAgentSpeech(agent,controller.signal);
          if(silentReady&&silentVersion===serial&&!destroyed&&visible())publish('presenting');
        }
        return;
      }
      hub.clients.forEach(function (client) { if (client !== api) client.stop(); });
      var introParagraph = overlay.querySelector('.bean-chat-intro-message p');
      var language = contentLanguage || (isIntro && overlay.dataset.beanConversation !== 'recommendation' && introParagraph ? introParagraph.dataset.copyLanguage || 'zh' : 'zh');
      language = normalizeLanguage(language);
      var selectedLanguage = normalizeLanguage(overlay.dataset.beanLanguage || (window.AppCenterLanguage && window.AppCenterLanguage.current));
      if (language === 'zh' && dialects[selectedLanguage]) language = selectedLanguage;
      // Preserve Min Nan selection so it follows the explicit same-gender dialect fallback policy.
      if (selectedLanguage === 'nan-TW' && (language === 'zh' || language === 'zh-TW')) language = 'nan-TW';
      var voice = voiceForLanguage(language, agent);
      activeMessage.language=language;
      var support=availability(language,agent);
      var requestId = serial;
      var speechRecorded = false, spokenChunks = new Set(), pendingSpeech = new Map();
      function recordPlayed(value, chunkKey) {
        if (stale() || spokenChunks.has(chunkKey)) return;
        spokenChunks.add(chunkKey);
        if (!activeMessage.agentGreeting) {
          var explanation = String(value || '').replace(/^(?:你好[啊呀哇]?|您好[啊呀哇]?|嗨，您好|哈喽，您好|很高兴见到您)，我是[^。\n]+。\s*/, '').trim();
          if (explanation) explainedContexts.add(explanationContext());
        }
        publish('playing',value);
        if (!speechRecorded) {
          speechRecorded = true;
          if (window.SiteAnalytics) window.SiteAnalytics.track('feature_trigger', { feature: 'agent_speech_started' });
        }
        var count = Array.from(value || '').filter(function (character) { return !/\s/.test(character); }).length;
        if (count && window.SiteAnalytics) window.SiteAnalytics.track('feature_trigger', { feature: 'agent_speech_characters', count: count });
      }
      function recordWhenRunning(value, chunkKey, scheduledStart) {
        if (spokenChunks.has(chunkKey) || pendingSpeech.has(chunkKey)) return;
        var clock = hub.context, timer = null;
        function cleanup() {
          clearTimeout(timer); clock.removeEventListener('statechange', check);
          signal.removeEventListener('abort', cleanup); pendingSpeech.delete(chunkKey);
        }
        function check() {
          clearTimeout(timer);
          if (stale() || signal.aborted) { cleanup(); return; }
          if (clock.state !== 'running') return;
          var remaining = (scheduledStart || 0) - clock.currentTime;
          if (remaining > 0) { timer = setTimeout(check, Math.max(1, Math.ceil(remaining * 1000))); return; }
          cleanup(); recordPlayed(value, chunkKey);
        }
        pendingSpeech.set(chunkKey, cleanup);
        clock.addEventListener('statechange', check);
        signal.addEventListener('abort', cleanup, { once: true }); check();
      }
      controller = new AbortController();
      var signal = controller.signal;
      function stale() { return destroyed || requestId !== serial || hub.muted || !visible(); }
      function unavailable(reason) { overlay.dataset.beanSpeech = 'unavailable'; button.title = '声音';notice(''); }
      function browserSpeakOnce(fallbackText,chunkIndex) {
        overlay.dataset.beanSpeech = 'loading';
        return waitForBrowserVoice(language, agent, signal).then(function (selectedVoice) {
          if (stale()) return;
          if (!selectedVoice) { unavailable(); return; }
          if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) { unavailable(); return; }
          var utterance = new window.SpeechSynthesisUtterance(fallbackText);
          // Never delegate to an unidentified default: it may be Xiaoyan or the wrong gender/language.
          utterance.lang = selectedVoice ? selectedVoice.lang : language === 'yue' ? 'yue-HK' : language;
          if (selectedVoice) utterance.voice = selectedVoice;
          browserUtterance = utterance;
          utterance.onstart = function () { if (!stale()) { overlay.dataset.beanSpeech = 'playing'; recordPlayed(fallbackText, 'browser-'+chunkIndex); } };
          return deadline(new Promise(function (resolve) {
            finishPlayback = resolve;
            function complete(error) {
              if (browserUtterance === utterance) { browserUtterance = null; finishPlayback = null; if (error) unavailable(); else overlay.dataset.beanSpeech = 'idle'; }
              resolve();
            }
            utterance.onend = function () { complete(false); }; utterance.onerror = function () { complete(true); };
            window.speechSynthesis.speak(utterance);
          }), Math.max(options.timeoutMs || 15000, fallbackText.length * 600), signal).catch(function(error){if(!stale()){window.speechSynthesis.cancel();unavailable(error.message);}});
        });
      }
      function browserSpeak(fallbackText) {
        return splitText(fallbackText).reduce(function(previous,sentence,chunkIndex) {
          return previous.then(function() {
            if(stale() || overlay.dataset.beanSpeech==='unavailable')return;
            if(activeMessage)activeMessage.remainingText=splitText(fallbackText).slice(chunkIndex).join('');
            return browserSpeakOnce(sentence,chunkIndex).then(function(){if(!stale() && overlay.dataset.beanSpeech!=='unavailable'){if(activeMessage)activeMessage.remainingText=splitText(fallbackText).slice(chunkIndex+1).join('');publish('ended',sentence);}});
          });
        },Promise.resolve());
      }
      if (overlay.waitForAgentSpeech) {
        overlay.dataset.beanSpeech='waiting-entry';
        var ready=await overlay.waitForAgentSpeech(agent,signal);
        if(stale())return;
        if(!ready){overlay.dataset.beanSpeech='unavailable';return;}
      }
      if(activeMessage&&activeMessage.agentGreeting)publish('presenting');
      if (!voice) return browserSpeak(text);
      introPending = Boolean(isIntro);
      unlock();
      if (!hub.context) return browserSpeak(text);
      var failedIndex = 0, prefetched = null;
      function fetchChunk(index) {
        // Warm exactly the next sentence while this sentence plays. Playback,
        // bubbles and handoff checkpoints still advance only in their original order.
        return deadline(fetch('/api/iflytek-tts/synthesize', {
          method:'POST',headers:{'Content-Type':'application/json'},signal:signal,
          body:JSON.stringify({text:chunks[index],voice:voice||undefined,stream:true})
        }),options.timeoutMs||15000,signal).then(response=>({response}),error=>({error}));
      }
      function next(index) {
        if (stale() || index >= chunks.length) return Promise.resolve();
        failedIndex = index;
        if(activeMessage)activeMessage.remainingText=chunks.slice(index).join('');
        overlay.dataset.beanSpeech = 'loading';
        var pending=prefetched&&prefetched.index===index?prefetched.work:fetchChunk(index);
        prefetched=null;
        return pending.then(function(result){if(result.error)throw result.error;return result.response;}).then(function (response) {
          if (!response.ok) { var failure = new Error('Speech unavailable'); failure.status = response.status; throw failure; }
          if(!stale()&&index+1<chunks.length)prefetched={index:index+1,work:fetchChunk(index+1)};
          if (response.headers && /application\/x-ndjson/.test(response.headers.get('Content-Type') || '')) {
            return playStream(response, hub.context, signal, function (scheduledStart) {
              streaming = true;
              recordWhenRunning(chunks[index], index, scheduledStart);
              overlay.dataset.beanSpeech = hub.context.state === 'running' ? 'playing' : 'waiting-interaction';
            }, options.timeoutMs || 15000).then(function () { streaming = false; return null; });
          }
          return deadline(response.arrayBuffer(),options.timeoutMs || 15000,signal);
        }).then(function (audio) {
          if (!audio || stale()) return null;
          return deadline(new Promise(function (resolve, reject) { hub.context.decodeAudioData(audio, resolve, reject); }),options.timeoutMs || 15000,signal);
        }).then(function (buffer) {
          if (!buffer || stale()) return;
          return deadline(new Promise(function (resolve) {
            source = hub.context.createBufferSource();
            var playingSource = source;
            source.buffer = buffer;
            source.connect(hub.context.destination);
            finishPlayback = resolve;
            source.onended = function () {
              playingSource.disconnect();
              if (source === playingSource) { source = null; finishPlayback = null; }
              resolve();
            };
            overlay.dataset.beanSpeech = hub.context.state === 'running' ? 'playing' : 'waiting-interaction';
            source.start();
            recordWhenRunning(chunks[index], index);
          }),Math.max(options.timeoutMs || 15000,(buffer.duration || 0)*1000+15000),signal);
        }).then(function () { if (!stale()) {if(activeMessage)activeMessage.remainingText=chunks.slice(index+1).join('');publish('ended',chunks[index]);return next(index + 1);} });
      }
      // Retry an opening once only before any audio has been scheduled/played.
      // A closed/muted/switched dialog must never be revived by this retry.
      return next(0).catch(function (error) {
        if (!isIntro || speechRecorded || error.audioStarted || stale() ||
            error.name === 'AbortError' || error.name === 'TimeoutError' ||
            (error.status && error.status < 500)) throw error;
        return new Promise(function (resolve) { setTimeout(resolve, 300); }).then(function () {
          if (stale() || signal.aborted) return;
          return next(failedIndex);
        });
      }).then(function () {
        if (requestId === serial) { controller = null; introPending = false; overlay.dataset.beanSpeech = 'idle'; }
      }).catch(function (error) {
        pendingSpeech.forEach(function (cleanup) { cleanup(); });
        if (requestId !== serial) return;
        introPending = false;
        streaming = false;
        if (error.name === 'TimeoutError') { if(controller)controller.abort();if(source){try{source.stop();}catch(_){}source.disconnect();source=null;}unavailable(error.message);return; }
        if (error.audioStarted && !stale()) { unavailable(); button.title = error.message; return; }
        if (error.name !== 'AbortError' && !stale()) return browserSpeak(chunks.slice(failedIndex).join(''));

      });
    }

    function speak(text, agent, isIntro, contentLanguage, metadata) {
      function retainedCreation() {
        return overlay.querySelector('.reference-template-result[data-dispatch-type="create"]') ||
          (window.MobileCenters && window.MobileCenters.creationHistory && window.MobileCenters.creationHistory());
      }
      var creationHistory = metadata && metadata.creationOpening && retainedCreation();
      var work=runSpeech(text,agent,isIntro,contentLanguage,metadata), version=serial;
      return Promise.resolve(work).then(function(){
        if(version!==serial&&agentHandoff&&agentHandoff.interruptedVersion===version)return agentHandoff.work;
        var status=version!==serial?'cancelled':hub.muted?'muted':!visible()?'cancelled':overlay.dataset.beanSpeech==='unavailable'?'failed':'completed';
        if(version===serial){publish(status);activeMessage=null;}
        if (text && status === 'completed' && creationHistory &&
            retainedCreation() === creationHistory) {
          return speak('智造初步开放（快速成长中），用户可尝试使用。', agent, false, 'zh');
        }
        return {status:status};
      },function(error){if(version===serial){publish('failed');activeMessage=null;}return {status:version===serial?'failed':'cancelled'};});
    }

    var openingWork = null, waitingOpeningAgent = false;
    function open() {
      var agent = options.getAgent();
      var selected = window.UniverseAgentScene && window.UniverseAgentScene.selected;
      if (selected && String(selected.key) !== String(agent && agent.key)) {
        waitingOpeningAgent = true;
        stop();
        return Promise.resolve({status:'waiting-agent'});
      }
      currentAgent = agent && agent.key;
      if (!agent || agent.key === 'universe-agent-fallback' || agent.name === '智体助手') {
        waitingOpeningAgent = true;
        stop();
        return Promise.resolve({status:'waiting-agent'});
      }
      waitingOpeningAgent = false;
      var text = options.getIntro();
      if(agent&&agent.name&&text)text=text.replace(/^(你好[啊呀哇]?|您好[啊呀哇]?|嗨，您好|哈喽，您好|很高兴见到您)，我是(?:宇宙之幂的|【宇宙之幂】的智体)[^。\n]+。/,function(_,greeting){return greeting+'，我是宇宙之幂的'+agent.name+'。';});
      var work = speak(text, agent, true, options.getIntroLanguage && options.getIntroLanguage(), {creationOpening:true});
      var version = serial;
      openingWork = work;
      return work.then(function (result) {
        if (openingWork === work) openingWork = null;
        if (text && result.status === 'completed' && version === serial && visible()) {
          return Promise.resolve(window.UniverseFixedCreation && window.UniverseFixedCreation.afterOpening(overlay, api, agent)).then(function () { return result; });
        }
        return result;
      });
    }

    function agentChanged() {
      if (options.autoRestart === false) return;
      var agent = options.getAgent();
      var nextKey = agent && agent.key;
      if (nextKey === currentAgent) return;
      var hadAgent=Boolean(currentAgent&&currentAgent!=='universe-agent-fallback');
      var interrupted=activeMessage&&activeMessage.agentGreeting?agentHandoff&&agentHandoff.interrupted:activeMessage&&activeMessage.remainingText?Object.assign({},activeMessage):null;
      var frameExplanation=window.MobileCenters&&window.MobileCenters.hasExplanationStarted&&window.MobileCenters.hasExplanationStarted(overlay);
      var skipExplanation=typeof frameExplanation==='boolean'?frameExplanation:explainedContexts.has(explanationContext());
      var interruptedVersion=serial;
      currentAgent = nextKey;
      stop();
      // A new identity owns a fresh introduction, including its visible copy.
      // Defer until other change listeners finish updating the current module.
      var version = serial;
      if(!hadAgent){
        if(visible()&&!destroyed)Promise.resolve().then(function(){if(version===serial&&visible()&&!destroyed)open();});
        return;
      }
      if (visible() && !destroyed) {
        var handoff={interruptedVersion:interruptedVersion,interrupted:interrupted,work:null};
        agentHandoff=handoff;
        handoff.work=Promise.resolve().then(async function () {
        if (version !== serial || !visible() || destroyed || (options.getAgent() || {}).key !== nextKey) return;
        window.DialogIntroduction && window.DialogIntroduction.begin();
        if(!window.DialogIntroduction||!window.DialogIntroduction.identity)return open();
        var identity=window.DialogIntroduction.identity(),language=(options.getIntroLanguage&&options.getIntroLanguage())||(interrupted&&interrupted.language)||'zh';
        language=normalizeLanguage(language);
        var translated=await (window.OpeningCopy&&window.OpeningCopy.translateText&&window.OpeningCopy.translateText(identity,language));
        if(version!==serial||!visible()||destroyed)return {status:'cancelled'};
        var text=(translated&&translated.text)||identity;language=(translated&&translated.language)||'zh';
        var thread=overlay.querySelector('.bean-chat-thread,.chat-thread,#messages');
        if(thread){var row=document.createElement('div'),copy=document.createElement('p');row.className='bean-chat-row is-assistant message-bubble';copy.className='bean-chat-bubble message-text';copy.dataset.chatTextDelegated='true';copy.textContent=text;row.append(copy);thread.append(row);}
        var greeting=speak(text,agent,false,language,{agentGreeting:true}),greetingVersion=serial;
        var result=await greeting;
        if(agentHandoff&&agentHandoff!==handoff)return agentHandoff.work;
        if(!result||result.status!=='completed'||greetingVersion!==serial||!visible()||destroyed)return result;
        // A newly opened/reused frame may have no active sentence to resume.
        // Its retained opening still owns the module introduction after the greeting.
        var continuation=skipExplanation ? '' : interrupted ? interrupted.remainingText : options.getIntro();
        var remaining=String(continuation||'').trim();
        [text,identity].forEach(function(prefix){if(prefix&&remaining.indexOf(prefix)===0)remaining=remaining.slice(prefix.length).trim();});
        remaining=remaining.replace(/^(?:你好[啊呀哇]?|您好[啊呀哇]?|嗨，您好|哈喽，您好|很高兴见到您)，我是(?:宇宙之幂的|【宇宙之幂】的智体)[^。\n]+。\s*/,'');
        if(remaining){
          var continuationLanguage=interrupted?interrupted.language:(options.getIntroLanguage&&options.getIntroLanguage())||language;
          var continued=speak(remaining,agent,false,continuationLanguage,interrupted?Object.assign({},interrupted,{agent:agent}):{creationOpening:true});
          var continuationVersion=serial;
          result=await continued;
          if(!interrupted&&result&&result.status==='completed'&&continuationVersion===serial&&visible()){
            await Promise.resolve(window.UniverseFixedCreation&&window.UniverseFixedCreation.afterOpening(overlay,api,agent));
          }
        }
        return result;
      }).finally(function(){if(agentHandoff===handoff)agentHandoff=null;});
      }

    }

    function introduceOnClick(event) {
      if((!event.detail||event.detail.owner!==overlay)||!visible()||destroyed)return;
      var agent=options.getAgent();
      if(String(agent&&agent.key)!==String(event.detail.key))return;
      var text=window.DialogIntroduction&&window.DialogIntroduction.identity();
      if(!text)return;
      var thread=overlay.querySelector('.bean-chat-thread,.chat-thread,#messages');
      if(thread){var row=document.createElement('div'),copy=document.createElement('p');row.className='bean-chat-row is-assistant message-bubble';copy.className='bean-chat-bubble message-text';copy.textContent=text;row.append(copy);thread.append(row);}
      speak(text,agent,true);
    }

    function retryAgentMedia(event) {
      if(!event.detail||event.detail.owner!==overlay||!visible()||destroyed||!lastMessage)return;
      speak(lastMessage.text,lastMessage.agent,lastMessage.isIntro,lastMessage.language,lastMessage);
    }
    window.addEventListener('universe-agent-media-retry',retryAgentMedia);

    function languageChanged() {
      if (options.autoRestart === false) return;
      stop();
      var version = serial;
      Promise.resolve(window.AppCenterCopyRuntime ? window.AppCenterCopyRuntime.refresh() : undefined)
        .then(function () { if (version === serial && visible()) open(); })
        .catch(function () { /* Keep the retained copy silent if translation failed. */ });
    }

    function storage(event) {
      if (event.key === key || event.key === null) {
        try { hub.muted = owner.localStorage.getItem(key) === 'true'; } catch (_) {}
        hub.clients.forEach(function (client) { client.syncMuted(); });
      }
    }
    function hide() { if (document.hidden || !visible()) stop(); }
    function pagehide(event) { if (event.persisted) stop(); else api.destroy(); }
    var observer = new MutationObserver(hide);
    observer.observe(overlay, { attributes: true, attributeFilter: ['hidden', 'aria-hidden'] });
    var api = {
      open: open, speak: speak, stop: stop, syncMuted: syncMuted, unlock: unlock,
      resetExplanationTurn: function () { explainedContexts.delete(explanationContext()); },
      isOpening: function () { return openingWork !== null; },
      isSwitchingAgent: function () { return agentHandoff !== null; },
      isMuted: function () { return hub.muted; },
      sequence: function () { return serial; },
      setMuted: function (value) {
        hub.muted = Boolean(value);
        try { owner.localStorage.setItem(key, String(hub.muted)); } catch (_) {}
        hub.clients.forEach(function (client) { client.syncMuted(); });
        if (!hub.muted) {unlock();if(options.resumeOnUnmute!==false && lastMessage && visible())return speak(lastMessage.text,lastMessage.agent,lastMessage.isIntro,lastMessage.language,lastMessage);}
      },
      destroy: function () {
        destroyed = true;
        window.removeEventListener('universe-agent-media-retry',retryAgentMedia);
        stop();
        observer.disconnect();
        document.removeEventListener('pointerdown', unlock, true);
        document.removeEventListener('keydown', unlock, true);
        document.removeEventListener('visibilitychange', hide);
        window.removeEventListener('universe-agent-changed', agentChanged);
        window.removeEventListener('agent-scene:introduce', introduceOnClick);
        window.removeEventListener('dialog:language-change', languageChanged);
        window.removeEventListener('universe-bean-language-change', languageChanged);
        window.removeEventListener('storage', storage);
        window.removeEventListener('pagehide', pagehide);
        hub.clients = hub.clients.filter(function (client) { return client !== api; });
      }
    };
    hub.clients.push(api);
    document.addEventListener('pointerdown', unlock, true);
    document.addEventListener('keydown', unlock, true);
    document.addEventListener('visibilitychange', hide);
    window.addEventListener('universe-agent-changed', agentChanged);
    window.addEventListener('agent-scene:introduce', introduceOnClick);
    window.addEventListener('dialog:language-change', languageChanged);
    window.addEventListener('universe-bean-language-change', languageChanged);
    window.addEventListener('storage', storage);
    window.addEventListener('pagehide', pagehide);
    syncMuted();
    return api;
  }
  function creationAnswerText(container, text) {
    var result = container.querySelector('.reference-template-result[data-dispatch-type="create"]');
    var copy = result && result.dataset.creationSpeech;
    return copy || text;
  }
  function stopAll() {
    hub.clients.slice().forEach(function (client) { client.stop(true); });
    var frame = window;
    try {
      while (frame.location.origin === window.location.origin) {
        if (frame.ContactSpeech) frame.ContactSpeech.stop();
        if (frame.parent === frame) break;
        frame = frame.parent;
      }
    } catch (_) {}
  }
  window.UniverseBeanSpeech = { stopAll: stopAll, creationAnswerText: creationAnswerText, playStream: playStream, create: create, prepareFixedText: prepareFixedText, languageVoices: languageVoices, dialects: dialects, normalizeLanguage: normalizeLanguage, voiceForLanguage: voiceForLanguage, browserVoice: browserVoice, genderForAgent: genderForAgent, waitForBrowserVoice: waitForBrowserVoice, messageForNode:messageForNode, availability:availability, voiceHint:voiceHint };
})();



//////////////////
// WEBPACK FOOTER
// ./homepage-source/bean-chat-speech.js
// module id = dt2F
// module chunks = 1